<template>
    <div class="rounded bg-white shadow p-4">

        <div class="flex">
            <div class="">
                <a class="cursor-pointer rounded-full flex flex-row bg-teal text-white py-2 items-center hover:bg-teal-dark"
                   @click="editY = true">
                    <div class="lg:px-8 px-4">
                        <span class=""><i class="fa fa-chevron-down"></i></span>
                    </div>
                    <div class="flex flex-col">
                        <div class="text-sm text-grey-lighter font-bold uppercase">
                            Y-axis
                        </div>
                        <span class="pr-4 lg:pr-16">{{ y.text }}</span>
                    </div>
                </a>
                <modal v-if="editY" @close="editY=false">
                    <template slot="header">Select Y-axis</template>
                    <single-select-filter :database="database" class="bg-white" @code="handleY"></single-select-filter>
                </modal>
            </div>
        </div>

        <div class="flex-1 my-4">
            <div v-show="loading" class="bg-grey-light w-full h-64"></div>

            <div v-show="!loading">
                <!--<h2 v-if="hasData">{{ headlineX }} vs {{ headlineY }}</h2>-->

                <div ref="chart"></div>
            </div>

        </div>

        <div class="flex justify-center">

            <div class="">
                <a class="cursor-pointer rounded-full flex flex-row bg-teal text-white py-2 items-center hover:bg-teal-dark"
                   @click="editX = true">
                    <div class="lg:px-8 px-4">
                        <span class=""><i class="fa fa-chevron-down"></i></span>
                    </div>
                    <div class="flex flex-col">
                        <div class="text-sm text-grey-lighter font-bold uppercase">
                            X-axis
                        </div>
                        <span class="pr-4 lg:pr-16">{{ x.text }}</span>
                    </div>
                </a>
                <modal v-if="editX" @close="editX=false">
                    <template slot="header">Select X-axis</template>
                    <single-select-filter :database="database" class="bg-white" @code="handleX"></single-select-filter>
                </modal>
            </div>

        </div>

        <div class="pt-2 text-grey text-right text-sm">Source: World Bank, Washington</div>

    </div>
</template>

<script>

    import DatabaseFilter from "../components/database/Filter";
    import SingleSelectFilter from "../components/database/SingleSelectFilter";
    import Modal from "../dashboard/components/Modal";

    export default {

        components: {
            SingleSelectFilter,
            DatabaseFilter,
            Modal,
        },

        provide() {
            return {
                codes: this.codes,
            }
        },

        watch: {
            step() {
                if (this.step === 3) {
                    this.doChart();
                }
            }
        },

        mounted() {
            this.loadData(this.x.id, true);
            this.loadData(this.y.id, false);
        },

        data() {
            return {
                editX: false,
                editY: false,
                step: 1,
                database: 'wb_wdi',
                codes: {
                    selected: [],
                },
                x: {
                    "id": "1554",
                    "text": "Life expectancy at birth, total (years)",
                    "children": false,
                    "type": "indicator",
                    "path": ["1", "1445", "1529"]
                },
                y: {
                    "id": "518",
                    "text": "GDP per capita (current US$)",
                    "children": false,
                    "type": "indicator",
                    "path": ["1", "149", "497", "498", "515"]
                },
                loading: false,
                dataX: null,
                dataY: null,
            };
        },

        computed: {
            headlineX() {
                return this.dataX.headline.map(function (item) {
                    return item.content;
                }).join('');
            },

            headlineY() {
                return this.dataY.headline.map(function (item) {
                    return item.content;
                }).join('');
            },

            hasData() {
                return this.dataX !== null && this.dataY !== null;
            },
            series() {
                if (!this.hasData) {
                    return [];
                }

                // extract last data point

                let x = _.keyBy(this.getLatest(this.dataX), function (item) {
                    return item.name;
                });

                let y = _.keyBy(this.getLatest(this.dataY), function (item) {
                    return item.name;
                });

                let result = _.map(x, function (x, key) {
                    if (y[key] === undefined) {
                        return null;
                    }

                    return {
                        name: key,
                        x: x.value,
                        y: y[key].value,
                    }
                });

                return [{
                    //name: 'Values',
                    colorByPoint: true,
                    data: result,
                }];

            },
            minX() {
                if (!this.hasData) {
                    return null;
                }

                let x = this.getLatest(this.dataX).map(function (item) {
                    return item.value;
                });

                return Math.min(...x);
            },
            maxX() {
                if (!this.hasData) {
                    return null;
                }

                let x = this.getLatest(this.dataX).map(function (item) {
                    return item.value;
                });

                return Math.max(...x);
            }
        },

        methods: {
            getLatest(result) {
                return result.data.map(function (series) {
                    let latest = series.observations[series.observations.length - 1];

                    return {
                        name: series.description,
                        value: latest.value,
                        time: latest.time,
                    };
                });
            },
            handleX(code) {
                this.x = code;
                this.editX = false;
                this.loadData(this.x.id, true);
            },
            handleY(code) {
                this.y = code;
                this.editY = false;
                this.loadData(this.y.id, false);
            },
            loadData(field, isX) {

                this.loading = true;

                // TODO optimize this query! pleanty of room: e.g. limit to latest data only!
                window.http
                    .get(
                        '/api/v1/indicators/' + this.database + '/data',
                        {
                            params: {
                                1: [field],
                                latest: true,
                            },
                        }
                    )
                    .then(response => {
                        if (isX) {
                            this.dataX = response.data.charts[0];
                        }

                        if (!isX) {
                            this.dataY = response.data.charts[0];
                        }

                        this.loading = false;
                        this.doChart();
                    }, response => {
                        this.error = response.data;
                        this.loading = false;
                    });
            },
            doChart() {
                if (!this.hasData) {
                    return false;
                }

                const json = {
                    chart: {
                        renderTo: this.$refs.chart,
                        type: 'scatter',
                    },
                    title: {
                        text: '', //this.headlineX + '<br/>vs.<br/>' + this.headlineY,
                    },
                    xAxis: {
                        gridLineWidth: 1,
                        labels: {
                            format: '{value}'
                        },
                        type: 'linear',
                        min: this.minX,
                        max: this.maxX,
                        startOnTick: true,
                        endOnTick: true,
                        title: {
                            text: this.x.text,
                        },
                    },
                    yAxis: {
                        title: {
                            text: this.y.text,
                        },
                    },
                    tooltip: {
                        headerFormat: '{point.key}<br>',
                        pointFormat: this.x.text + ': <b>{point.x:.2f}</b><br>' + this.y.text + ': <b>{point.y:.2f}</b>',
                    },
                    series: this.series,
                    legend: {
                        enabled: false,
                    },
                    exporting: {
                        buttons: {
                            contextButton: {
                                enabled: false,
                            }
                        }
                    },
                    credits: {
                        enabled: false,
                        href: 'https://www.allthatstats.com/',
                        text: 'Source: ' + 'World Bank, Washington',
                    },
                };

                new Highcharts.Chart(json);
            }
        }
    }
</script>